/*! @azure/msal-common v15.6.0 2025-05-06 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.6.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
